/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Pinnacle = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
                setTimeout(function() {
                    $('body, html').scrollTop(0);
                    $('.load-overlay').velocity('fadeOut');
                }, 100);

                $(".liquid").imgLiquid();

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        // Notice that the class 'page-home' becomes 'page_home'
        'page_home': {
            init: function() {
                // JavaScript to be fired on the home page
                console.log("It works!");
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Pinnacle;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    // $( ".menu-icon" ).click(function() {
    //   $(".mobile-nav").fadeToggle('fast');
    // });

    // $( ".mobile-nav-close" ).click(function() {
    //   $(".mobile-nav").fadeToggle('fast');
    // });


     $(".navbar-toggle").on("click", function() {
         $(".mobile-nav").toggleClass("open");
     });
    
    // $(function() {
    //   $('a[href*="#"]:not([href="#"])').click(function() {
    //     if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    //       var target = $(this.hash);
    //       target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    //       if (target.length) {
    //         $('html, body').animate({
    //           scrollTop: target.offset().top
    //         }, 1000);
    //         return false;
    //       }
    //     }
    //   });
    // });

    //our-team bios
    $('.profile').click(function(){
      var showing = $(this).is('.bio-show');
      $('.bio-show').addClass('bio-hide').removeClass('bio-show');
      $('.profile-bio').fadeOut();
      if (showing) {
        return;
      }
      if ( $(this).is('.bio-hide') ) {
        $(this).addClass('bio-show').removeClass('bio-hide');
        $(this).children('.profile-bio').fadeIn();
      } else {
        $(this).addClass('bio-hide').removeClass('bio-show');
        $(this).children('.profile-bio').fadeOut();
      }
    });

    $(".location-marker").hover(function () {
      if ( $(window).width() > 992 )
        $(this).parents().children('.location-name').fadeIn('fast');
    }, function () {
      if ( $(window).width() > 992 )
        $(this).parents().children('.location-name').fadeOut('fast');
    });

    $("[data-toggle=\"popover\"]").popover({placement : "bottom"});
    $("[data-toggle=\"popover\"]").on("click", function(e) {
        e.preventDefault();
    });

    // Our-members/Testimonials - Click of a directional button
    $('#our-members .testimonial-carousel .carousel-arrow-nav button').click(function(){

        var direction = $(this).data('direction');
        var slides = $('#our-members .testimonial-carousel .carousel').children();
        var dots = $('#our-members .testimonial-carousel .carousel-dots').children();

        for(var i=0; i< slides.length; i++) {

            if($(slides[i]).hasClass('active')) {

                // Deactivate the currently active slide and dot
                $(slides[i]).removeClass('active');
                $(dots[i]).removeClass('active');

                if(direction == 'next') {

                    if( i == (slides.length - 1)) {

                        $(slides[0]).addClass('active');
                        $(dots[0]).addClass('active');

                    } else {

                        $(slides[i + 1]).addClass('active');
                        $(dots[i + 1]).addClass('active');

                    }

                } else if(direction == 'previous') {

                    if( i == 0) {

                        $(slides[(slides.length - 1)]).addClass('active');
                        $(dots[(slides.length - 1)]).addClass('active');

                    } else {

                        $(slides[i - 1]).addClass('active');
                        $(dots[i - 1]).addClass('active');

                    }

                }

                break;

            }

        }

    });

    // Our-members/Testimonials - Click of a navigational dot
    $('#our-members .testimonial-carousel .carousel-dots .dot').click(function(){
        var index = $(this).index();
        var slides = $('#our-members .testimonial-carousel .carousel').children();
        var dots = $('#our-members .testimonial-carousel .carousel-dots').children();

        // Remove class from all slides and dots
        $('#our-members .testimonial-carousel .carousel .testimonial-slide.active').removeClass('active');
        $('#our-members .testimonial-carousel .carousel-dots .dot.active').removeClass('active');

        // Activate the desired slide and dot
        $(slides[index]).addClass('active');
        $(dots[index]).addClass('active');

    });

    $('select[name="request_type"]').change(function(){
        togglePrivacyRequestSubmit($(this).val());
    });

    $('button#submit-modal-trigger').click(function() {
        $(this).addClass('d-none');
        $('div#modal-privacy-request-are-you-sure').removeClass('d-none');
        $('div#modal-privacy-request-are-you-sure').slideDown();
        displayModalBodyContent($('select[name="request_type"]').val());
    });

    $('button#close-modal').click(function(){
        $('div#modal-privacy-request-are-you-sure').addClass('d-none');
        togglePrivacyRequestSubmit($('select[name="request_type"]').val());
    });

    $('#privacy-notification-button').on('click', function() {
        var maxAge = 10 * 365 * 24 * 60 * 60; // 10 years in seconds
        document.cookie = 'hideCmsPrivacyNotificationBanner=true; max-age='+maxAge+'; path=/';
        $('#privacy-notification-banner').hide();
    });

    detectDisplayPosition($('#leadership ul.profiles li.profile'));
    detectDisplayPosition($('#experts ul.profiles li.profile'));

    $(window).resize(function(){
        detectDisplayPosition($('#leadership ul.profiles li.profile'));
        detectDisplayPosition($('#experts ul.profiles li.profile'));
    });

    if(!getCookie('hideCmsPrivacyNotificationBanner')) {
        $('#privacy-notification-banner').removeClass('d-none');
    }

    function getCookie( name ) {
        var parts = document.cookie.split(name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

        $(function() {
        var rotation = 0;
        $.fn.rotate = function(degrees) {
            $(this).css({"-webkit-transform" : "rotate("+ degrees +"deg)",
                         "-moz-transform" : "rotate("+ degrees +"deg)",
                         "-ms-transform" : "rotate("+ degrees +"deg)",
                         "transform" : "rotate("+ degrees +"deg)"});
            return $(this);
        };
        $(".plus-icon").on("click", function() {
            $(this).find("svg").toggleClass("rotate45");
        });
      var visiblePopovers = [];
      var $body = $("body");
      function hideVisiblePopovers() {
        $.each(visiblePopovers, function() {
          $(this).find("svg").removeClass("rotate45");
          $(this).popover("hide");
        });
      }
      function showVisiblePopovers() {
        $.each(visiblePopovers, function() {
          $(this).find("svg").rotate(45);
        });
      }
      function onBodyClick(event) {
        if (event.isDefaultPrevented())
          return;
        var $target = $(event.target);
        if ($target.data("bs.popover"))
          return;
        if ($target.parents(".popover").length)
          return;
        hideVisiblePopovers();
      }
      function onBodyKeyup(event) {
        if (event.isDefaultPrevented())
          return;
        if (event.keyCode != 27) // esc
          return;
        hideVisiblePopovers();
        event.preventDefault();
      }
      function onPopoverShow(event) {
        var target = event.target;
        if (!visiblePopovers.length) {
          $body.on("click", onBodyClick);
          $body.on("keyup", onBodyKeyup);
          //visiblePopovers.find("svg").rotate(-45);
        }
        visiblePopovers.push(event.target);
      }
      function onPopoverHide(event) {
        var target = event.target;
        var index = visiblePopovers.indexOf(target);
        if (index > -1) {
          visiblePopovers.splice(index, 1);
        }
        if (visiblePopovers.length == 0) {
          $body.off("click", onBodyClick);
          $body.off("keyup", onBodyKeyup);
        }
      }
      $body.on("show.bs.popover", onPopoverShow);
      $body.on("hide.bs.popover", onPopoverHide);
    });

    var vid=document.getElementById("hp-video");
    if(vid){
      vid.addEventListener("ended", resetVideo, false);
    }

    function resetVideo() {
        // resets the video element by resetting the source
        this.src = this.src;
    }

    function togglePrivacyRequestSubmit(rightToExercise)
    {
        $('button#submit-form').removeClass('d-none');
        $('button#submit-modal-trigger').addClass('d-none');

        if (rightToExercise == 'right-to-delete') {
            $('button#submit-modal-trigger').removeClass('d-none');
            $('button#submit-form').addClass('d-none');
        }

        if (rightToExercise == 'right-to-know') {
            $('fieldset#subrequest-types-radio').show();
            $('fieldset#subrequest-types-radio input[name="subrequest_type"]').attr('required', 'required');
        } else {
            $('fieldset#subrequest-types-radio').hide();
            $('fieldset#subrequest-types-radio input[name="subrequest_type"]').removeAttr('required');
        }

        if (rightToExercise == 'right-to-optout') {
            $('button#submit-modal-trigger').removeClass('d-none');
            $('button#submit-form').addClass('d-none');
            $('fieldset#subrequest-types-optout-radio').show();
            $('fieldset#subrequest-types-optout-radio input[name="subrequest_type"]').attr('required', 'required');
        } else {
            $('fieldset#subrequest-types-optout-radio').hide();
            $('fieldset#subrequest-types-optout-radio input[name="subrequest_type"]').removeAttr('required');
        }
    }

    function displayModalBodyContent(rightToExercise)
    {
        $('div#modal-privacy-request-are-you-sure .modal-body-right-to-delete').hide();
        $('div#modal-privacy-request-are-you-sure .modal-body-right-to-optout').hide();

        if(rightToExercise == 'right-to-delete') {
            $('div#modal-privacy-request-are-you-sure .modal-body-right-to-delete').show();
        }

        if(rightToExercise == 'right-to-optout') {
            $('div#modal-privacy-request-are-you-sure .modal-body-right-to-optout').show();
        }

    }

    function detectDisplayPosition(selector)
    {

        var displayWidth = selector.parent().width() + 40; // 40 for padding

        // Remove values potentially set in a previous runtime
        selector.removeAttr('data-display-direction');

        selector.each(function(index){

            var position = $(this).position();
            var remainingDisplayLeftRealEstate = position.left;
            var remainingDisplayRightRealEstate = displayWidth - (position.left + 149);
            var bioMinWidth = 400;

            if (displayWidth < 875) {
                bioMinWidth = 300;
            }

            var detailsDisplayDirection = 'below';

            if (displayWidth < 800) {
                detailsDisplayDirection = 'below';
            } else if (remainingDisplayRightRealEstate >= bioMinWidth) {
                detailsDisplayDirection = 'right';
            } else if (remainingDisplayLeftRealEstate >= bioMinWidth) {
                detailsDisplayDirection = 'left';
            }

            $(this).attr('data-display-direction', detailsDisplayDirection);

        });

    }

    // Form for Dropdown with Site Selection
    $('#dropdownSitesForm').on("submit", function(e) {
        e.preventDefault();
        selectedSiteUrl = $('#dropdownMenuSelect :selected').val();
        if (selectedSiteUrl == "") {
            displayErrorMakeSelection();
            return;
        }
        window.open(selectedSiteUrl, '_blank');
    });
    $('#dropdownMenuSelect').on('change', function() {
        selectedSiteUrl = $('#dropdownMenuSelect :selected').val();
        if (selectedSiteUrl != "") {
            hideErrorMakeSelection();
        }
    });

    function displayErrorMakeSelection()
    {
        $('#error-make-selection').text('Please make your selection.');
        $('#error-make-selection').removeClass('d-none');
        $('#dropdownMenuSelect').removeClass('dropdown-normal');
        $('#dropdownMenuSelect').addClass('dropdown-error');
        $('#dropdownMenuSelect').focus();

    }

    function hideErrorMakeSelection()
    {
        $('#error-make-selection').text();
        $('#error-make-selection').addClass('d-none');
        $('#dropdownMenuSelect').removeClass('dropdown-error');
        $('#dropdownMenuSelect').addClass('dropdown-normal');
    }

})(jQuery); // Fully reference jQuery after this point.